import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Base_Url } from '../config';

const AddAdvancedServiceCard = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    // State for form data
    const [serviceData, setServiceData] = useState({
        title1: '',
        title2: '',
        title3: '',
        route_id: id || null
    });

    // State for form submission status
    const [isSubmitting, setIsSubmitting] = useState(false);


    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setServiceData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Validate form data
    const validateForm = () => {
        const errors = [];
    
        // if (!serviceData.title1 || serviceData.title1.trim() === '') {
        //     errors.push('Main Heading is required');
        // }
    
        // if (!serviceData.title2 || serviceData.title2.trim() === '') {
        //     errors.push('Info is required');
        // }
    
        // if (!serviceData.title3 || serviceData.title3.trim() === '') {
        //     errors.push('Card Heading is required');
        // }
    

        if (errors.length === 3) {
            return errors; 
        }
    
        return [];
    };
    

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form
        const validationErrors = validateForm();
        
        if (validationErrors.length > 0) {
            validationErrors.forEach(error => 
                toast.error(error, { 
                    position: "top-right",
                    autoClose: 3000
                })
            );
            return;
        }

        // Prevent multiple submissions
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            // Prepare submission data
            const submissionData = {
                title1: serviceData.title1.trim(),
                title2: serviceData.title2.trim(),
                title3: serviceData.title3.trim(),
                route_id: serviceData.route_id
            };

            // Submit to API
            const response = await axios.post(`${Base_Url}/card-descriptions`, submissionData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            // Success handling
            toast.success('Card Description Added Successfully!', {
                position: "top-right",
                autoClose: 3000,
                onClose: () => {
                    // Reset form or navigate
                    setServiceData({
                        title1: '',
                        title2: '',
                        title3: '',
                        route_id: id || null
                    });
                    // Optional: Navigate to another page
                    navigate('/');
                }
            });

        } catch (error) {
            // Error handling
            console.error('Submission Error:', error);
            
            const errorMessage = error.response?.data?.message || 
                                  error.response?.data?.error || 
                                  'Description Already Exists';
            
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container mt-5">
            <ToastContainer />
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h2 className="text-center mb-0">Add Card Description</h2>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="title1" className="form-label">Main Heading</label>
                                    <input
                                        type="text"
                                        id="title1"
                                        className="form-control"
                                        name="title1"
                                        placeholder="Enter Main Heading"
                                        value={serviceData.title1}
                                        onChange={handleChange}
                                        maxLength={255}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="title2" className="form-label">Info</label>
                                    <input
                                        type="text"
                                        id="title2"
                                        className="form-control"
                                        name="title2"
                                        placeholder="Enter Additional Info"
                                        value={serviceData.title2}
                                        onChange={handleChange}
                                        maxLength={255}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="title3" className="form-label">Card Heading</label>
                                    <input
                                        type="text"
                                        id="title3"
                                        className="form-control"
                                        name="title3"
                                        placeholder="Enter Card Heading"
                                        value={serviceData.title3}
                                        onChange={handleChange}
                                        maxLength={255}
                                    />
                                </div>

                                <div className="text-center">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary btn-lg"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Adding...' : 'Add Card Description'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddAdvancedServiceCard;